'use client'
import { publicEnv } from '@/shared/config/publicEnv'

import { useState, type ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { NuqsAdapter } from 'nuqs/adapters/next/app'
import '@/assets/styles/global.css'
import { Auth0Provider } from '@auth0/nextjs-auth0'

type Props = {
    children: ReactNode
}

if (publicEnv.mock === 'true' && publicEnv.nodeEnv === 'development') {
    void import('../mocks')
}

export default function RootLayout({ children }: Props) {
    // One client for the life of the tree. A new one on each render dropped the
    // cache, the flag values with it, on every `router.refresh()`.
    const [queryClient] = useState(() => new QueryClient())
    return (
        <NuqsAdapter>
            <QueryClientProvider client={queryClient}>
                <Auth0Provider>{children}</Auth0Provider>
            </QueryClientProvider>
        </NuqsAdapter>
    )
}
